import { ComparatorSelectType } from '../types';
import { SelectOption } from '../../../../contexts';
import { Comparator } from '../../../../types';
import { useTranslation } from '../../../../hooks/useTranslation';

export const useCreateComparatorOptions = () => {
  const { t } = useTranslation();
  return (
    comparators: Record<string, Comparator>,
    type: ComparatorSelectType,
  ): SelectOption<Comparator>[] =>
    Object.values(comparators).map((comparator) => ({
      title: t(`v2.conditionBuilder.comparator.${type}.${comparator}`),
      value: comparator,
    }));
};
